import React, { useContext, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import 'Pages/Doctor/DoctorDashboard/doctorDashboard.scss';
import { LocaleContext } from 'routes/Router';
import { ClearTokenRedirectLogin } from 'utils/general';
import { useDispatch, useSelector } from 'react-redux';
import { getDashboard } from 'store/dashboard/dashboardAction';
import DoctorUpcomingList from './DasboardUpcomingList';
import DashoardPatientList from './DashboardPatientList';
import DashboardCardData from './DashboardCardData';
import CommonToast from 'components/commom/CommonToast';

const DoctorDashboard = () => {
  const navigate = useNavigate();
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();

  const profileDisableData = useSelector(
    (state) => state?.profileSectionDataReducer?.users?.data
  );

  useEffect(() => {
    getDoctorDashboard();
  }, []);

  const getDoctorDashboard = () => {
    const external = {
      run: true,
      handleFunction: (res) => {},
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getDashboard(external));
  };

  return (
    <Row className="bc-FEF9F6 m-0 p-0">
      {profileDisableData?.title?.id === 10 ? (
        <Col className="min-h-[90vh] flex flex-col items-center justify-content-center">
          <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600  m-0">
            {`Welcome, ${profileDisableData?.full_name}`}
          </h2>
          <h5 className="fc-292D32 family_outfit_semiBold_600 mt-4 m-0">
            {profileDisableData?.subscription
              ? `Great news! Patients can now see your profile. Keep it fresh and updated.`
              : `Almost there! Finish your profile to be visible to patients.`}
          </h5>
        </Col>
      ) : (
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer  lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <DashboardCardData />
          <DoctorUpcomingList />
          <DashoardPatientList />
        </Col>
      )}
    </Row>
  );
};

export default DoctorDashboard;
